module.exports = __webpack_public_path__ + "img/Intranet_Head.08be7dab.png";